import React from "react";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import tableStyle from "../../assets/jss/material-dashboard-react/components/tableStyle.jsx";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import PropTypes from "prop-types";

const CustomerTable = props => {
  let { data } = props;
  const { classes, tableHeaderColor } = props;
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        <TableHead
          className={classes[tableHeaderColor + "TableHeader"]}
          style={{ color: "#8e24aa" }}
        >
          <TableRow>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              CustomerVehicle ID
            </TableCell>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              CalBit ID
            </TableCell>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              Make
            </TableCell>
            <TableCell
              className={classes.tableCell + " " + classes.tableHeadCell}
            >
              Year
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(item => {
            return (
              <TableRow key={item.id}>
                <TableCell className={classes.tableCell}>{item.customerVehicleId}</TableCell>
                <TableCell className={classes.tableCell}>
                  {item.id}
                </TableCell>
                <TableCell className={classes.tableCell}>
                {item.make}
                </TableCell>
                <TableCell className={classes.tableCell}>
                {item.vehicleYear}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Link
                    to={{
                      pathname: `/customer/vehicle/${item.id}`
                    }}
                  >
                    Details
                  </Link>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
// CustomerTable.defaultProps = {
//   tableHeaderColor: "gray"
// };

// CustomerTable.propTypes = {
//   classes: PropTypes.object.isRequired,
//   tableHeaderColor: PropTypes.oneOf([
//     "warning",
//     "primary",
//     "danger",
//     "success",
//     "info",
//     "rose",
//     "gray"
//   ]),
//   tableHead: PropTypes.arrayOf(PropTypes.string),
//   tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
// };
export default withStyles(tableStyle)(CustomerTable);



// WEBPACK FOOTER //
// ./src/admin/customer/CustomerTable.jsx